export default __webpack_public_path__ + "static/media/ProposalFirstViewIcon.b91c900e.svg";